import { isEmpty } from 'lodash-es';
import React, { useState } from 'react';

import { SimpleTabs } from '~/src/dash/components/tabs/SimpleTabs';
import { SimpleTabSections } from '~/src/dash/components/tabs/SimpleTabSections';
import { Panel, Panels, spacing } from '~/src/dash/publicaUI';
import { useBaseConfig } from '~/src/dash/views/base/contexts';
import { AudienceManagerSettingsListView } from '~/src/dash/views/segments/audience/AudienceManagerSettingsListView';
import { DataPartnerLanding } from '~/src/dash/views/segments/audience/AudienceSegments/tabs/DataPartnerLanding';
import { TopBar } from '~/src/dash/views/topbar/TopBar';

export const AudienceSegments = () => {
  const [key, _] = useState(0);
  const { AudienceSegments } = useBaseConfig();
  const cfg = AudienceSegments.AudienceSegments.Main;
  const [activeTabIndex, setActiveTabIndex] = useState(cfg?.defaultState?.activeTabIndex || 0);

  const handleChangeTab = (_event: React.SyntheticEvent, index: number) => {
    setActiveTabIndex(index);
    if (!isEmpty(cfg?.defaultState)) {
      cfg.defaultState.activeTabIndex = index;
    }
  };

  return (
    <Panels max vertical relative minWidthMain>
      <Panel largeHorizontalPadding smallVerticalPadding>
        <TopBar title='Audience Manager' enableUINotices />
      </Panel>
      <Panel>
        <SimpleTabs
          activeTabIndex={activeTabIndex}
          ariaLabel='Bidders'
          handleChangeTab={handleChangeTab}
          tabs={cfg.tabs}
        />
      </Panel>
      <Panel scroll paddingTop={spacing.small}>
        <SimpleTabSections
          key={key}
          activeTabIndex={activeTabIndex}
          sections={[<AudienceManagerSettingsListView />, <DataPartnerLanding />]}
        />
      </Panel>
    </Panels>
  );
};
